import configObject from "@/config";

export const serviceMixins = {
    methods: {
        getServices() {
            this.showLoader = true;

            this.axios
                .get(
                    `${configObject.apiBaseUrl}/Service/Branch/${this.branch.id}/Get/All`,
                    configObject.authConfig()
                )
                .then((response) => {
                    console.log(response.data)
                    this.services = response.data
                    this.showLoader = false;
                    response.data.forEach((el, i) => {
                        el.text = el.name
                        el.value = el.id
                    })
                })
                .catch((error) => {
                    this.showLoader = false;
                });
        },
    }
}